<template>
	<div>
		<v-row class="mt-3">
			<v-col cols="6" sm="6" md="2" lg="2" xl="2" class="py-1">
				<h4>Item</h4>
				<span>{{ itemSelecionado.item }}</span>
			</v-col>
			<v-col cols="6" sm="6" md="2" lg="2" xl="2" class="py-1">
				<h4>Tipo</h4>
				<span>{{ itemSelecionado.tipo }}</span>
			</v-col>
			<v-col cols="6" sm="6" md="4" lg="4" xl="4" class="py-1">
				<h4>Unidade Aquisição</h4>
				<span>{{ itemSelecionado.unidadeAquisicao }}</span>
			</v-col>
			<v-col cols="6" sm="6" md="2" lg="2" xl="2" class="py-1">
				<h4>Preço</h4>
				<span>{{ valorUnitario }}</span>
			</v-col>
			<v-col cols="6" sm="6" md="2" lg="2" xl="2" class="py-1">
				<h4>Marca</h4>
				<span>{{ marca }}</span>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" class="py-1">
				<h4>Descrição</h4>
				<texto-tooltip :texto="itemSelecionado.descricao" :tamanho-maximo="textoTamanhoMaximo"></texto-tooltip>
			</v-col>
		</v-row>
		<v-row class="mb-5">
			<v-col cols="6" md="6" lg="6" xl="6" class="py-1">
				<h4>Fornecedor</h4>
				<v-combobox
					:rules="regrasFornecedor"
					placeholder="Selecione o Fornecedor"
					:items="fornecedores"
					item-value="id"
					item-text="razaoSocial"
					v-model="realinhar.fornecedor"
					@change="selecionarItemFornecedor"
					dense
					clearable
				></v-combobox>
			</v-col>
			<v-col cols="6" md="6" lg="6" xl="6" class="py-1">
				<h4>Classificação</h4>
				<span>{{ getClassificacaoSelecionada() }}</span>
			</v-col>
		</v-row>
		<v-divider></v-divider>
		<div class="py-3">
			<v-row>
				<v-col cols="12" md="6" lg="6" xl="6" class="py-3">
					<label-personalizado nome-campo="Novo valor"></label-personalizado>
					<az-money
						v-model="realinhar.novoValor"
						placeholder="Informe por valor"
						:negative="false"
						:requeridMessage="'Este é campo é obrigatório'"
						:maxLength="300"
						show-clear-button
						class="ma-0 py-0"
						:precision="numeroCasasDecimaisValores"
					></az-money>
				</v-col>
				<v-col cols="12" md="6" lg="6" xl="6" class="py-3">
					<label-personalizado nome-campo="Nova marca"></label-personalizado>
					<v-text-field
						v-model="realinhar.novaMarca"
						class="ma-0 py-0"
						placeholder="Informe nova marca"
					></v-text-field>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="6" lg="6" xl="6" class="py-0">
					<label-personalizado nome-campo="Justificativa" obrigatorio-por-padrao></label-personalizado>
					<v-textarea
						v-model="realinhar.justificativa"
						placeholder="Informe a justificativa"
						:rules="regrasJustificativa"
						counter="300"
						hide-details="auto"
						rows="2"
						class="ma-0 py-0"
					></v-textarea>
				</v-col>

				<v-col cols="12" md="6" lg="6" xl="6" class="py-0">
					<label-personalizado
						nome-campo="Arquivo"
						:apresentaTooltip="true"
						:mensagemPadraoTooltip="`Você só pode adicionar 1 arquivo com as extensões: ${LABEL_EXTENSOES.join(
							', ',
						)}`"
						:obrigatorioPorPadrao="false"
					></label-personalizado>
					<campo-arquivo-novo
						id="modal-novo-anexo-campo-arquivo"
						:validate="{ required: false }"
						name="Arquivo"
						:multiplo-arquivos="true"
						:extensoes-permitidas="EXTENSOES_ARQUIVO"
						show-selected
						height="'64px'"
						@input="tratarEventoAnexoSelecionado"
						@apagar-anexo="apagarAnexo"
						:errorUpload.sync="errorUpload"
					></campo-arquivo-novo>
				</v-col>
			</v-row>
		</div>
	</div>
</template>
<script>
import { actionTypes, mutationTypes, tipoModeloDocumento } from '@/core/constants'
import { mapState } from 'vuex'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import classificacaoFilter from '@/views/filters/fornecedor/classificacao-filter'

export default {
	name: 'realinhamento-realinhar',
	mixins: [validacaoFormulario],
	props: {
		itemSelecionado: {
			type: Object,
			default() {
				return {}
			},
		},
	},
	data() {
		return {
			regrasJustificativa: [
				(value) => this.regraObrigatoriedade(value, 'A justificativa é obrigatória.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						300,
						'O campo de justificativa deve ser igual ou menor que 300 caracteres!',
					),
			],
			regrasFornecedor: [
				(value) => this.regraObrigatoriedade(value, 'O campo do Fornecedor deve ser preenchido!'),
				(value) => {
					return value && value.id ? true : 'O campo do Fornecedor deve ser preenchido!'
				},
			],
			fornecedores: [],
			textoTamanhoMaximo: 400,
			tipoModeloDocumento: tipoModeloDocumento.ATA_REGISTRO_PRECO,
			EXTENSOES_ARQUIVO: [],
			errorUpload: false,
		}
	},
	computed: {
		...mapState({
			realinhar: (state) => state.itemAta.realinhamento.realinhar,
			infoAta: (state) => state.ata.informacoesAta,
		}),
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisValores
			},
		},
		valorUnitario() {
			const fornecedor = this.realinhar.fornecedor

			return fornecedor && fornecedor.valorUnitario
				? this.$options.filters.azCurrency(fornecedor.valorUnitario, this.numeroCasasDecimaisValores)
				: '-'
		},
		marca() {
			return this.realinhar.fornecedor && this.realinhar.fornecedor.marca ? this.realinhar.fornecedor.marca : '-'
		},
	},
	async created() {
		this.carregarListaExtensoesAceitas()
	},
	async mounted() {
		await this.buscarFornecedores()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.REALINHAMENTO.REALINHAMENTO.RESET_REALINHAR)
	},
	methods: {
		async buscarFornecedores() {
			const { itens } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.ALTERAR_FORNECEDOR.ALTERAR.BUSCAR_FORNECEDORES,
				this.itemSelecionado.id,
			)
			this.fornecedores = itens
			if (itens.length > 0) {
				this.realinhar.fornecedor = itens[0]
				this.realinhar.idFornecedorItemAta = this.realinhar.fornecedor.id
			}
		},

		async selecionarItemFornecedor(fornecedor) {
			if (fornecedor && fornecedor.id) {
				this.realinhar.idFornecedorItemAta = fornecedor.id
			} else {
				this.realinhar.fornecedor = null
				this.realinhar.idFornecedorItemAta = null
			}
		},
		carregarListaExtensoesAceitas() {
			this.EXTENSOES_ARQUIVO = this.getListTextConstant(this.extensoesArquivos, 'value')
			this.LABEL_EXTENSOES = this.getListTextConstant(this.extensoesArquivos, 'text')
		},
		getClassificacaoSelecionada() {
			if (this.realinhar.fornecedor && this.realinhar.fornecedor.classificacao) {
				return classificacaoFilter(this.realinhar.fornecedor.classificacao)
			}

			return '-'
		},
		async tratarEventoAnexoSelecionado(anexoModels) {
			await this.adicionarAnexo(anexoModels)
		},
		getFormArquivoTemporario(file) {
			return {
				file: file,
				idExternoPasta: this.infoAta.idPastaExternaDigital,
				repositorioFlowbee: this.infoAta.repositorioFlowbee,
			}
		},
		async apagarAnexo(posicao) {
			await this.$store.dispatch(
				actionTypes.ARQUIVO.EXCLUIR_ARQUIVO_TEMPORARIO,
				this.realinhar.idsExternoAnexoFlowbee[posicao].idExterno,
			)

			this.realinhar.idsExternoAnexoFlowbee.splice(posicao, 1)
		},
		async adicionarAnexo(anexoSelecionado) {
			try {
				const formData = this.getFormArquivoTemporario(anexoSelecionado)
				const arquivo = await this.$store.dispatch(actionTypes.ARQUIVO.ENVIAR_ARQUIVO_TEMPORARIO, formData)
				this.realinhar.idsExternoAnexoFlowbee.push({ idExterno: arquivo.id, nome: arquivo.nome })
			} catch (e) {
				this.errorUpload = true
			}
		},
	},
}
</script>
